// @ts-strict-ignore
import { Transforms } from 'slate';
import { MentionElement } from 'src/components/textEditor/customTypes';

// plugin - needs to wrap the editor to make mentions work
export const withMentions = editor => {
  const { isInline, isVoid, exec } = editor;

  // custom command for adding mentions
  // calling custom commands: editorPost.exec({ type: 'insert_mention', mentionedUser: $my-value });
  editor.exec = command => {
    if (command.type === 'insert_mention') {
      const mention = {
        type: 'mention',
        mentionedUser: command.mentionedUser,
        children: [{ text: '' }],
      } as MentionElement;

      Transforms.insertNodes(editor, mention);
      Transforms.move(editor);
    } else {
      // Call the existing behavior to handle any other commands.
      exec(command);
    }
  };

  editor.isInline = element => {
    return element.type === 'mention' ? true : isInline(element);
  };

  editor.isVoid = element => {
    return element.type === 'mention' ? true : isVoid(element);
  };

  return editor;
};
